export const RequestTypeEnum = Object.freeze({
    create: "Create",
    delete: "Delete",
    update: "Update",
});
